$('.nav-pill-mobile .pill-list-item.pill-clickable').on('click', function(){
	//$( this ).find( ".pill-grandchildren" ).fadeToggle();
	$( this ).find( "svg" ).toggleClass('rotate-180');
	$( this ).toggleClass('expand');
});

class CollectionFilterToggle extends HTMLElement {
	constructor() {
		super();

		this.addEventListener('click', e => {
			document.documentElement.classList.toggle('collection-filter-toggle');
		});
	}
}

customElements.define('collection-filter-toggle', CollectionFilterToggle);


class CollectionLink extends HTMLElement {
	static promises = new Map();

	constructor() {
		super();

		this.url = this.getAttribute('url');
		this.promise = null;
		
		let handle = null;

		this.addEventListener('mouseover', e => {
			handle = setTimeout(() => {
				this.fetchCollection();
			}, 80);
		});

		this.addEventListener('mouseout', e => {
			if (handle) {
				clearTimeout(handle);
				handle = null;
			}
		});

		this.addEventListener('click', async e => {
			e.preventDefault();

			if (this.onClick) this.onClick();

			if (this.type == 'checkbox') {
				if (this.hasAttribute('active')) this.removeAttribute('active');
				else this.setAttribute('active', '');
			}
			else if (this.type == 'radio') {
				this.parentElement.querySelectorAll(this.tagName).forEach(link => {
					link.classList.remove('selected');
				});
				this.classList.add('selected');
			}

			const content = document.getElementById('collection-content');
			content.classList.add('loading');
			content.querySelector('.collection__filter-menu-buttons collection-filter-toggle').classList.add('show-loading', 'show-loading--inverted');

			const html = await this.fetchCollection();

			history.replaceState({}, '', this.url.toString());

			const doc = new DOMParser().parseFromString(html, 'text/html');
			
			const newContent = doc.getElementById('collection-content');
			content.replaceWith(newContent);

			const top = document.querySelector('#collection-top').getBoundingClientRect().top;
			const headerHeight = document.querySelector('site-header').clientHeight;
			if (top < headerHeight) {
				window.scrollTo(0, window.scrollY + top - headerHeight - 8);
			}
		});
	}

	fetchCollection() {
		const section = this.closest('.shopify-section');
		const sectionId = section.id.replace('shopify-section-', '');
		const url = new URL(this.url, window.location.href);
		url.searchParams.set('section_id', sectionId);
		const urlString = url.toString();

		if (CollectionLink.promises.has(urlString)) return CollectionLink.promises.get(urlString);
		const promise = fetch(url.toString()).then(resp => resp.text());
		CollectionLink.promises.set(urlString, promise);
		return promise;
	}
}

customElements.define('collection-link', CollectionLink);

class CollectionSort extends HTMLElement {
	constructor() {
		super();

		if (CollectionSort.open) this.setAttribute('open', '');

		this.querySelector('.collection-sort__toggle').addEventListener('click', e => {
			e.preventDefault();
			if (this.hasAttribute('open')) this.removeAttribute('open');
			else this.setAttribute('open', '');
		});

		window.addEventListener('click', e => {
			if (this.hasAttribute('open') && 
				!this.contains(e.target) && 
				e.target != this
			) {
				this.removeAttribute('open');
			}
		}, { capture: true });
	}
}

customElements.define('collection-sort', CollectionSort);

class CollectionSortItem extends CollectionLink {
	constructor() {
		super();

		this.type = 'radio';
		this.value = this.getAttribute('value');
		this.default = this.hasAttribute('default');

		const url = new URL(window.location.href);
		url.searchParams.delete('page');
		if (this.default) url.searchParams.delete('sort_by');
		else url.searchParams.set('sort_by', this.value);

		this.url = url.toString();
	}
}

customElements.define('collection-sort-item', CollectionSortItem);

class CollectionTab extends CollectionLink {
	constructor() {
		super();

		this.type = "radio";
	}

	connectedCallback() {
		if (this.classList.contains('selected')) this.scrollToCenter();
	}

	onClick() {
		this.scrollToCenter();
	}

	scrollToCenter() {
		this.scrollIntoView({behavior: 'auto', inline: 'center', block: 'nearest'});
	}
}

customElements.define('collection-tab', CollectionTab);

class CollectionFilters extends HTMLElement {
	static scroll = 0;

	constructor() {
		super();

		this.addEventListener('scroll', e => {
			CollectionFilters.scroll = this.scrollTop;
		});

		this.scrollTop = CollectionFilters.scroll;
	}
}

customElements.define('collection-filters', CollectionFilters);

class CollectionFilter extends HTMLElement {
	static open = new Map();
	static expanded = new Map();
	static initialised = false;

	constructor() {
		super();  
		const details = this.querySelector('details');

		details.addEventListener('toggle', e => {
			if (details.hasAttribute('open')) {
				CollectionFilter.open.set(this.id, true);
			}
			else CollectionFilter.open.set(this.id, false);
		});

		if (CollectionFilter.open.has(this.id)) {
			details.open = CollectionFilter.open.get(this.id);
		}

		this.querySelector('.collection-filter__expand').addEventListener('click', e => {
			e.preventDefault();
			this.ariaExpanded = this.ariaExpanded == 'true' ? 'false' : 'true';
			CollectionFilter.expanded.set(this.id, this.ariaExpanded === 'true');
			this.update();
		});

		if (CollectionFilter.expanded.has(this.id)) {
			this.ariaExpanded = CollectionFilter.expanded.get(this.id) === true ? 'true' : 'false';
			this.update();
		}

		window.addEventListener('click', e => {
			if (details.hasAttribute('open') && 
				!this.contains(e.target) && 
				e.target != this &&
				e.target.tagName != 'A' &&
				window.innerWidth > 992
			) {
				details.removeAttribute('open');
			}
		}, { capture: true });
	}

	connectedCallback() {
		if (!CollectionFilter.initialised) {
			if (window.innerWidth < 992) {
				const details = this.querySelector('details');
				details.setAttribute('open', '');
			}

			setTimeout(() => CollectionFilter.initialised = true, 1000);
		}
	}

	update() {
		const button = this.querySelector('.collection-filter__expand');
		if (this.ariaExpanded == 'true') button.innerText = 'Show Less';
		else button.innerText = 'Show More';
	}
}

customElements.define('collection-filter', CollectionFilter);

class CollectionFilterItem extends CollectionLink {
	static lastClicked = null;
	static lastClickedPos = null;

	constructor() {
		super();

		this.type = 'checkbox';
		this.active = this.hasAttribute('active');
		this.value = this.getAttribute('value');

		// Try to restore previous position on screen, to prevent jumping when selecting filters
		if (CollectionFilterItem.lastClicked === this.value) {
			CollectionFilterItem.lastClicked = null;
			this.closest('collection-filters').scrollBy(0, this.getRelativePos() - CollectionFilterItem.lastClickedPos);
		};
	}

	onClick() {
		CollectionFilterItem.lastClicked = this.value;
		CollectionFilterItem.lastClickedPos = this.getRelativePos();
	}

	getRelativePos() {
		const rect = this.getBoundingClientRect();
		const filterRect = this.closest('collection-filters').getBoundingClientRect();
		return rect.top - filterRect.top;
	}
}

customElements.define('collection-filter-item', CollectionFilterItem);


class ProductViewToggle extends HTMLElement {
	constructor() {
		super();

		const square = this.querySelector('#square');
		const tile = this.querySelector('#tile');

		square.addEventListener('click', e => {
			document.documentElement.classList.add('product-view-square');
			square.classList.add('active');
			tile.classList.remove('active');
		});

		tile.addEventListener('click', e => {
			document.documentElement.classList.remove('product-view-square');
			square.classList.remove('active');
			tile.classList.add('active');
		});
	}
}

customElements.define('product-view-toggle', ProductViewToggle);